module.exports = __webpack_public_path__ + "static/media/SB2019.0467aa91.jpg";